// extracted by mini-css-extract-plugin
export default {"header":"Process_header__Jda4O","warning":"Process_warning__4HSky"};